export default __webpack_public_path__ + "images/abbc1752bfdf36e69d3e08ba2f2ac698.png";